var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50781 9.34998V13.0916C2.50781 16.8333 4.00781 18.3333 7.74948 18.3333H12.2411C15.9828 18.3333 17.4828 16.8333 17.4828 13.0916V9.34998",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0017 10C11.5267 10 12.6517 8.75835 12.5017 7.23335L11.9517 1.66669H8.06003L7.5017 7.23335C7.3517 8.75835 8.4767 10 10.0017 10Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2596 10C16.943 10 18.1763 8.63335 18.0096 6.95835L17.7763 4.66669C17.4763 2.50002 16.643 1.66669 14.4596 1.66669H11.918L12.5013 7.50835C12.643 8.88335 13.8846 10 15.2596 10Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69868 10C6.07368 10 7.31535 8.88335 7.44868 7.50835L7.63201 5.66669L8.03202 1.66669H5.49035C3.30702 1.66669 2.47368 2.50002 2.17368 4.66669L1.94868 6.95835C1.78201 8.63335 3.01535 10 4.69868 10Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 14.1667C8.60964 14.1667 7.91797 14.8584 7.91797 16.25V18.3334H12.0846V16.25C12.0846 14.8584 11.393 14.1667 10.0013 14.1667Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.07ed905dacba5acbf81ed917a8103ee5.svg";
export { ForwardRef as ReactComponent };